export default "__VITE_ASSET__C9n3W18P__"